namespace $.$$ {

	$mol_style_define( $shm_ba_filter_panel, {
		width: '340px',
		minWidth: '300px',

		Title: {
			flex: {
				direction: 'column',
			},
			alignItems: 'stretch',
			padding: 0,
		},

		Filters_head: {
			display: 'flex',
			alignItems: 'center',
			width: '100%',
			gap: '6px',
		},

		Filters_title: {
			alignItems: 'center',
			flex: {
				shrink: 1,
				basis: 'auto',
			},
		},

		Summary_expand: {
			flex: {
				grow: 0,
				shrink: 0,
			},
		},

		Filters: {
			minWidth: 0,
			display: 'flex',
			flex: {
				direction: 'column',
			},
			gap: '14px',
		},

		Search_row: {
			display: 'grid',
			gridTemplateColumns: 'minmax(0, 1fr) 36px',
			alignItems: 'center',
		},

		Search_filter: {
			minWidth: 0,
		},

		Search_index_status: {
			font: {
				size: '12px',
				weight: 'normal',
			},
			whiteSpace: 'nowrap',
		},

		Search_submit: {
			alignItems: 'center',
			justifyContent: 'center',
			minWidth: '36px',
			minHeight: '36px',
			padding: 0,
		},

		Search_submit_icon: {
			width: '16px',
			height: '16px',
		},

		Process_monitor_toggle: {
			flex: {
				grow: 0,
				shrink: 0,
			},
		},

		Process_monitor_toggle_icon: {
			width: '1.25rem',
			height: '1.25rem',
		},

		Empty: {
			color: $mol_theme.shade,
			padding: {
				top: $mol_gap.block,
				bottom: $mol_gap.block,
			},
		},

		Filter_summary: {
			display: 'flex',
			flexWrap: 'wrap',
			alignItems: 'center',
			gap: '8px',
			minWidth: 0,
			userSelect: 'text',
			':empty': {
				display: 'none',
			},
		},

		Filter_summary_label: {
			minWidth: 0,
			maxWidth: '100%',
			color: $mol_theme.shade,
			whiteSpace: 'normal',
			overflowWrap: 'anywhere',
			font: {
				size: '13px',
			},
		},

		Filter_summary_more: {
			flex: {
				grow: 0,
				shrink: 0,
			},
			minHeight: 0,
			padding: {
				top: '2px',
				bottom: '2px',
				left: '6px',
				right: '6px',
			},
			font: {
				size: '13px',
				weight: 'normal',
			},
		},

		Filter_reset: {
			flex: {
				grow: 0,
				shrink: 0,
			},
			margin: {
				left: 'auto',
			},
		},

		Search_section: {
			Title: {
				display: 'flex',
			},
			Tools: {
				width: 'auto',
				margin: {
					left: 'auto',
				},
			},
		},

		Period_section: {
			flex: {
				direction: 'row',
			},
			Title: {
				display: 'flex',
			},
			Tools: {
				width: 'auto',
				margin: {
					left: 'auto',
				},
			},
		},

		Period_filter: {
			gap: 0,
			Date_from: {
				margin: {
					right: '-0.15rem'
				},
				Trigger: {
					padding: {
						left: '0.6rem',
						right: '0.6rem',
					},
				},
			},
			Date_to: {
				margin: {
					left: '-0.15rem'
				},
				Trigger: {
					padding: {
						left: '0.6rem',
						right: '0.6rem',
					},
				},
			},
		},

	} )

}
